import {
  CorporateInformationFormValues,
  IIncomeItemFormValues,
  IIncomeStructureFormValues,
  INatureOfBusinessFormValues,
} from '../NatureOfBusinessFormProvider/types';
import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { mapAssets } from '@Utils/assetUtils';
import {
  ICorporateInformation,
  IIncomeCategory,
  IIncomeItem,
  IIncomeStructure,
} from '@Domains/NatureOfBusiness';

export const mapNatureOfBussinessToPayload = (
  formValues: INatureOfBusinessFormValues,
  incomeMasterData: IInfoCategoryMasterData[]
) => {
  const introduction =
    !formValues?.introduction?.descriptionTh &&
    !formValues?.introduction?.descriptionEn
      ? null
      : formValues.introduction;

  const remark =
    !formValues?.remark?.descriptionTh && !formValues?.remark?.descriptionEn
      ? null
      : formValues.remark;

  let incomeStructure;
  if (formValues?.incomeStructure) {
    if (
      formValues.incomeStructure.introduction?.descriptionTh === null &&
      formValues.incomeStructure.introduction?.descriptionEn === null
    ) {
      formValues.incomeStructure.introduction = undefined;
    }

    if (
      !formValues.incomeStructure.remark?.descriptionTh &&
      !formValues.incomeStructure.remark?.descriptionEn
    ) {
      formValues.incomeStructure.remark = undefined;
    }

    incomeStructure = mapIncomeStructureV2ToPayload(
      formValues.incomeStructure as IIncomeStructureFormValues,
      incomeMasterData || []
    );
  }

  let corporateInformation;
  if (formValues?.corporateInformation) {
    const corpInfo = formValues.corporateInformation;
    const corpInfoThai = corpInfo.thai;
    const corpInfoEnglish = corpInfo.english;

    if (corpInfoEnglish.companyEn === null) {
      corpInfo.english.companyEn = '';
    }

    if (corpInfoEnglish.symbolEn === null) {
      corpInfo.english.symbolEn = '';
    }

    if (corpInfoEnglish.addressEn === null) {
      corpInfoEnglish.addressEn = '';
    }

    if (corpInfoEnglish.zipcodeEn === null) {
      corpInfoEnglish.zipcodeEn = '';
    }

    if (corpInfoEnglish.businessTypeEn === null) {
      corpInfoEnglish.businessTypeEn = '';
    }

    if (corpInfoEnglish.registeredNumberEn === null) {
      corpInfoEnglish.registeredNumberEn = '';
    }

    if (corpInfoEnglish.telephoneEn === null) {
      corpInfoEnglish.telephoneEn = '';
    }

    if (corpInfoEnglish.websiteEn === null) {
      corpInfoEnglish.websiteEn = '';
    }

    if (corpInfoEnglish.emailEn === null) {
      corpInfoEnglish.emailEn = '';
    }

    if (corpInfoThai.companyTh === null) {
      corpInfoThai.companyTh = '';
    }

    if (corpInfoThai.symbolTh === null) {
      corpInfoThai.symbolTh = '';
    }

    if (corpInfoThai.addressTh === null) {
      corpInfoThai.addressTh = '';
    }

    if (corpInfoThai.zipcodeTh === null) {
      corpInfoThai.zipcodeTh = '';
    }

    if (corpInfoThai.businessTypeTh === null) {
      corpInfoThai.businessTypeTh = '';
    }

    if (corpInfoThai.registeredNumberTh === null) {
      corpInfoThai.registeredNumberTh = '';
    }

    if (corpInfoThai.telephoneTh === null) {
      corpInfoThai.telephoneTh = '';
    }

    if (corpInfoThai.websiteTh === null) {
      corpInfoThai.websiteTh = '';
    }

    if (corpInfoThai.emailTh === null) {
      corpInfoThai.emailTh = '';
    }

    if (
      corpInfo.introduction?.descriptionTh === null &&
      corpInfo.introduction?.descriptionEn === null
    ) {
      corpInfo.introduction = undefined;
    }

    if (!corpInfo.remark?.descriptionTh && !corpInfo.remark?.descriptionEn) {
      corpInfo.remark = undefined;
    }

    corporateInformation = mapCorporateInformation(corpInfo);
  }

  const { productInformation, marketingIndustry, otherDescriptions } =
    formValues;

  if (productInformation) {
    if (
      productInformation.introduction?.descriptionTh === null &&
      productInformation.introduction?.descriptionEn === null
    ) {
      productInformation.introduction = undefined;
    }

    if (
      !productInformation.remark?.descriptionTh &&
      !productInformation.remark?.descriptionEn
    ) {
      productInformation.remark = undefined;
    }

    if (
      productInformation.businessGroupIntroduction?.descriptionTh === null &&
      productInformation.businessGroupIntroduction?.descriptionEn === null
    ) {
      productInformation.businessGroupIntroduction = undefined;
    }

    if (
      !productInformation.businessGroupRemark?.descriptionTh &&
      !productInformation.businessGroupRemark?.descriptionEn
    ) {
      productInformation.businessGroupRemark = undefined;
    }

    if (productInformation.businessGroupInfos) {
      productInformation.businessGroupInfos =
        productInformation.businessGroupInfos.map((group) => ({
          ...group,
          assets: mapAssets(group.assets) ?? [],
          nameEn: group.nameEn === null ? '' : group.nameEn,
        }));
    }
  }

  if (marketingIndustry) {
    if (
      marketingIndustry.introduction?.descriptionTh === null &&
      marketingIndustry.introduction?.descriptionEn === null
    ) {
      marketingIndustry.introduction = undefined;
    }

    if (
      !marketingIndustry.remark?.descriptionTh &&
      !marketingIndustry.remark?.descriptionEn
    ) {
      marketingIndustry.remark = undefined;
    }

    if (
      marketingIndustry.marketingPolicyIntroduction?.descriptionTh === null &&
      marketingIndustry.marketingPolicyIntroduction?.descriptionEn === null
    ) {
      marketingIndustry.marketingPolicyIntroduction = undefined;
    }

    if (
      !marketingIndustry.marketingPolicyRemark?.descriptionTh &&
      !marketingIndustry.marketingPolicyRemark?.descriptionEn
    ) {
      marketingIndustry.marketingPolicyRemark = undefined;
    }

    if (
      marketingIndustry.marketingPolicy &&
      marketingIndustry.marketingPolicy.length > 0
    ) {
      marketingIndustry.marketingPolicy = marketingIndustry.marketingPolicy.map(
        (policy) => {
          const updatedPolicy = { ...policy };

          if (
            !updatedPolicy.salesRatioIntroduction?.descriptionTh &&
            !updatedPolicy.salesRatioIntroduction?.descriptionEn
          ) {
            updatedPolicy.salesRatioIntroduction = undefined;
          }

          if (
            !updatedPolicy.salesRatioRemark?.descriptionTh &&
            !updatedPolicy.salesRatioRemark?.descriptionEn
          ) {
            updatedPolicy.salesRatioRemark = undefined;
          }

          updatedPolicy.assets = mapAssets(policy.assets) ?? [];

          return updatedPolicy;
        }
      );
    }
  }

  return {
    introduction,
    remark,
    incomeStructure,
    corporateInformation,
    productInformation,
    marketingIndustry,
    otherDescriptions,
  };
};

const mapCorporateInformation = (
  corporateInformation: CorporateInformationFormValues
): ICorporateInformation => {
  return {
    ...corporateInformation,
    ...corporateInformation.thai,
    ...corporateInformation.english,
  };
};

const mapIncomeStructureV2ToPayload = (
  incomeStructure: IIncomeStructureFormValues,
  incomeMasterData: IInfoCategoryMasterData[]
): IIncomeStructure => {
  const {
    productIncomeItems,
    exportIncomeItems,
    otherIncomeItems,
    productIncomePercentages,
    exportIncomePercentages,
    ...values
  } = incomeStructure;

  const incomeItems = mapIncomeEntriesToPayload(
    { ...productIncomeItems, ...exportIncomeItems, ...otherIncomeItems },
    incomeMasterData
  );

  const incomeItemPercents = mapIncomeEntriesToPayload(
    { ...productIncomePercentages, ...exportIncomePercentages },
    incomeMasterData
  );

  return {
    ...values,
    incomeItems,
    incomeItemPercents,
    assets: mapAssets(incomeStructure.assets) ?? [],
  } as IIncomeStructure;
};

const mapIncomeEntriesToPayload = (
  incomeItems?: Record<string, IIncomeItemFormValues>,
  incomeMasterData?: IInfoCategoryMasterData[]
): IIncomeItem[] => {
  if (!incomeItems) return [];

  return Object.entries(incomeItems)
    .filter(([_, value]) => Object.keys(value).length > 0)
    .reduce((acc, [incomeKey, value], index) => {
      const masterData = incomeMasterData?.find(
        (master) => master.id.toString() === incomeKey
      );
      acc[index] = mapIncomeItemToPayload(value, masterData);
      return acc;
    }, [] as IIncomeItem[]);
};

const mapIncomeItemToPayload = (
  incomeItem: IIncomeItemFormValues,
  masterData?: IInfoCategoryMasterData
): IIncomeItem => {
  const {
    asOfYear,
    asOfYesteryear,
    asOfYearBeforeYesteryear,
    incomeCategory,
    ...values
  } = incomeItem;

  return {
    ...values,
    asOfYear: parseValue(asOfYear),
    asOfYesteryear: parseValue(asOfYesteryear),
    asOfYearBeforeYesteryear: parseValue(asOfYearBeforeYesteryear),
    incomeCategory:
      masterData && !incomeCategory?.id
        ? mapIncomeCategoryMasterDataToPayload(masterData)
        : incomeCategory,
  } as IIncomeItem;
};

const parseValue = (value?: string): number | undefined =>
  value?.trim() ? parseFloat(value.trim()) : undefined;

const mapIncomeCategoryMasterDataToPayload = (
  masterData: IInfoCategoryMasterData
): IIncomeCategory => {
  return {
    nameTh: masterData.nameTh,
    nameEn: masterData.nameEn,
    infoCategoryMasterDataId: masterData.id,
    sequence: masterData.sequence,
  } as IIncomeCategory;
};
